"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWidgetData = void 0;
const VALID_REMOTE_HOSTS = [
    'https://inventwidgetstorage.z19.web.core.windows.net',
    'https://cdn.apptrium.cloud'
];
// we need this for local development of widgets
// and widgets with long ids like 100234, 999123
const stripWidgetIdForLocalhost = (widgetId) => {
    if (widgetId.length >= 6) {
        return widgetId.slice(-3);
    }
    return widgetId;
};
const getWidgetHost = (name, widgetId, version) => {
    const devFederation = DEV_FEDERATION;
    if (devFederation.includes(widgetId) ||
        devFederation.includes(name) ||
        version === 'dev-version') {
        return `http://localhost:5${stripWidgetIdForLocalhost(widgetId)}/remoteEntry.js`;
    }
    // BACK COMPAT for migration period. After migration will be completed this should be removed (Q1 2023)
    // Applicable for Widget-store-v1 and old type envs without version control components.
    if (!VALID_REMOTE_HOSTS.includes(window.STORE_BASE_URL)) {
        return `${window.STORE_BASE_URL}/${widgetId}/remoteEntry.js`;
    }
    return `${window.STORE_BASE_URL}/widgets/${widgetId}/${version}/remoteEntry.js`;
};
const getVersion = (version, versionAlias) => {
    if (version === 'dev-version' || !Boolean(versionAlias)) {
        return version;
    }
    return versionAlias;
};
const generateWidgetData = (platformMeta) => (name, widgetId) => {
    const widget = platformMeta.platformWidgetsById[widgetId] || platformMeta.storeWidgetsById[widgetId];
    const widgetVersion = getVersion(widget.version, widget.versionAlias);
    const [, widgetName] = name.split('_');
    return {
        scope: name,
        component: `./${widgetName}`,
        settings: `./${widgetName}Settings`,
        preview: `./${widgetName}Preview`,
        mocks: `./${widgetName}Mocks`,
        host: getWidgetHost(name, `${widgetId}`, widgetVersion)
    };
};
exports.generateWidgetData = generateWidgetData;
